<template>
  <ion-page>
    <ion-header :translucent="true">
      <HeaderContainer title="Profile" />
    </ion-header>
    <ion-content ref="profileContent" :fullscreen="true">
      <ion-refresher slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content :pulling-icon="chevronDownCircleOutline"
        pulling-text="Pull to refresh"
        refreshing-spinner="bubbles"
        ></ion-refresher-content>
      </ion-refresher>
      <div v-if="!isBlocked" class="dashboard" :style="'margin-top: 0px; border-radius:0;' + dashMarginOverride()">
        <div class="profile-banner-pic">
          <img v-if="profile.banner_pic != null && profile.banner_pic != ''" :src="bannerpath + profile.banner_pic"
            @click="openFullScreen(bannerpath + profile.banner_pic, '100%', '100%')">
          <div v-else
            style="display:block; background-color: rgba(var( --dashboard-urlblock-background-color-rgb), 1.0); width: 100%; height:200px;">
          </div>
        </div>
        <div v-if="!isBlocked" class="profile-header">
          <ion-grid>
            <ion-row>
              <ion-col size="sm">
                <div v-if="profile.profile_pic != null && profile.profile_pic != ''" class="profile-header-pic"
                  @click="openFullScreen(profilepath + profile.profile_pic, '100%', '100%')">
                  <img @error="imgUrlAlt" :src="profilepath + profile.profile_pic">
                </div>
                <div v-if="profile.profile_pic == '' || profile.profile_pic == undefined" class="profile-header-pic">
                  <img class="story-thumb-pic" src="/assets/spyguy.png">
                </div>
              </ion-col>
              <ion-col v-show="profile.user_name != null">
                <h2 class="profile"><span class="fullname">{{ profile.first_name }}<span style="padding-left:7px;"><UserBadges :ecb="profile.ecb" :certified="profile.certified" /></span></span> 
                  <ion-icon slot="icon-only" style="float:right; margin-right:5px; cursor:pointer;"
                    v-if="this.$store.state.auth.token != '' && isMyProfile" button @click="this.$router.push('/options')"
                    :icon="cog"></ion-icon>
                  <ion-icon slot="icon-only" style="float:right; margin-right:5px; cursor:pointer;"
                    v-if="!isMyProfile && this.$store.state.auth.token != ''" button @click="openBlockModal()"
                    :icon="ellipsisHorizontal"></ion-icon>
                  <ion-icon slot="icon-only" style="float:right; margin-right:5px; cursor:pointer;"
                    @click="openShareOtherModal" :icon="share"></ion-icon>
                </h2>
                <span class="username">@{{ profile.user_name }}</span><br />
                <div class="joined">{{ $t('buttons.joined') }} {{ profile.start_year }}</div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <p class="bio" style="white-space: pre-wrap;">{{ profile.bio }}</p>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="8" class="ion-align-self-center">
                <span @click="viewFriends('followme')" style="float:left; margin-right:15px; cursor: pointer;"><strong>{{
                  userStats.followers }}</strong> {{ $t('buttons.followers') }}</span>
                <span @click="viewFriends('myfollows')" style="float:left; cursor: pointer;"><strong>{{
                  userStats.following }}</strong> {{ $t('buttons.following') }}</span>
              </ion-col>
              <ion-col>
                <ion-chip v-if="profile.is_subscribed" color="primary" style="float: right; font-size: 0.6em;"><strong
                    v-if="profile.premium_content == 1">Subscribed</strong><strong
                    v-if="profile.premium_content != 1">Sponsored</strong></ion-chip>
              </ion-col>
            </ion-row>
            <ion-row v-if="!isMyProfile && this.$store.state.auth.token != ''">
              <ion-col>
                <!--<ion-button @click="openMessagesModal" expand="full" color="light">
                  <ion-icon slot="start" :icon="chatbubble"></ion-icon> Message
                </ion-button>-->
              </ion-col>
              <ion-col>
                <div v-if="profile.status != undefined">
                  <ion-button @click="toggleFriend(profile)" v-if="profile.status.id == 0" color="light" expand="full">
                    + <ion-icon style="font-size:24px;" :icon="person"></ion-icon><ion-icon
                      v-if="profile.status.private == 1" style="font-size:12px;" :icon="lockClosed"></ion-icon>
                    <span style="margin-left:5px;" v-if="profile.status.requested == 'yes'"><i>&nbsp; {{
                      $t('buttons.requested') }}</i></span><span style="margin-left:5px;"
                      v-if="profile.status.requested == 'no' && profile.status.private == 1">&nbsp; {{
                        $t('buttons.request')
                      }}</span><span style="margin-left:5px;" v-if="profile.status.private == 0">&nbsp; {{
  $t('buttons.follow') }}</span>
                  </ion-button>
                  <ion-button @click="toggleFriend(profile)" v-if="profile.status.id != 0" color="light" expand="full">
                    <ion-icon style="font-size:24px; color:rgba(var(--ion-color-primary-rgb), 1.0);"
                      :icon="person"></ion-icon><span
                      style="color:rgba(var(--ion-color-primary-rgb), 1.0);">&#10004;&nbsp; {{ $t('buttons.following')
                      }}</span>
                  </ion-button>
                </div>
              </ion-col>
            </ion-row>
            <ion-row v-if="this.$store.state.auth.token == ''">
              <ion-col>
                <ion-button @click="toggleFriend(profile)" color="light" expand="full">
                  + <ion-icon style="font-size:24px;" :icon="person"></ion-icon>
                  <span style="margin-left:5px;">&nbsp; {{ $t('buttons.follow') }}</span>
                </ion-button>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col v-if="profile.allwebsites != undefined && profile.allwebsites.length > 0">
                <ion-button @click="openPopover($event, profile)" expand="full" color="light">
                  <ion-icon slot="start" :icon="link"></ion-icon> {{ $t('buttons.websites') }}
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button v-if="this.$store.state.helpers.searchToggle == ''" @click="this.$router.push('/searchall')"
                  expand="full" color="light">
                  <ion-icon slot="start" :icon="search"></ion-icon> {{ $t('buttons.search') }}
                </ion-button>
              </ion-col>
            </ion-row>
            <ion-row v-if="profile.account_type == 'Premium' && getEnv('SUBSCRIPTIONS') == 1 && !checkIosApp()">
              <ion-col>
                <ion-button @click="openBuyModal" expand="full">
                  {{ displaySubscribeButton() }}
                </ion-button>
              </ion-col>
            </ion-row>
            <div v-if="getEnv('SUBSCRIPTIONS') == 1">
              <ion-row
                v-if="profile.has_subscriptions == true || (profile.account_type == 'Premium' && profile.premium_content == 1) && isMyProfile">
                <ion-col>
                  <ion-segment @ionChange="profileTypeChanged($event)" :value="profileSwitch">
                    <ion-segment-button value="stories">
                      <ion-label>{{ $t('buttons.posts') }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button v-if="profile.has_subscriptions == true" value="subscriptions">
                      <ion-label>{{ $t('buttons.subscriptions') }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button v-if="profile.account_type == 'Premium' && profile.premium_content == 1"
                      value="forsale">
                      <ion-label>{{ $t('buttons.mypremium') }}</ion-label>
                    </ion-segment-button>
                  </ion-segment>
                </ion-col>
              </ion-row>
              <ion-row v-if="profile.account_type == 'Premium' && profile.premium_content == 1 && !isMyProfile">
                <ion-col>
                  <ion-segment @ionChange="profileTypeChanged($event)" :value="profileSwitch">
                    <ion-segment-button value="stories">
                      <ion-label>{{ $t('buttons.posts') }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="subscriptions">
                      <ion-label>{{ $t('buttons.subscriptions') }}</ion-label>
                    </ion-segment-button>
                  </ion-segment>
                </ion-col>
              </ion-row>
            </div>
          </ion-grid>
        </div>
      </div>
      <div class="dashboard notfound" v-if="notFound">
        <strong>{{ $t('errors.profilenotfound') }}</strong>
        <p>{{ $t('errors.profilenotfound2') }}</p>
      </div>
      <div class="dashboard notfound" v-if="isBlocked">
        <strong>{{ $t('errors.profileblocked') }}</strong>
        <p>{{ $t('errors.profileblocked2') }}</p>
      </div>
      <FeedContainer :key="$route.fullPath" v-if="profileType == 'profile' || profileType == 'ownerpreviewpremium'"
        :streamName="profileType" :filter="filterType" :userid="profileid" :stories="profileStories"
        v-model:refreshFeed="refreshFeed" :scrollContainer="scrollElement" v-model:networkTimeout="timeout" />
      <FeedContainer v-else-if="profileType == 'myprofile' || profileType == 'premium' || profileType == 'ownerpremium'"
        :streamName="profileType" :filter="filterType" :userid="profileid" :stories="myProfileStories"
        v-model:refreshFeed="refreshFeed" :scrollContainer="scrollElement" v-model:networkTimeout="timeout" />
      <ion-fab id="posting-button" v-if="isMyProfile && this.$store.state.helpers.postToggle == ''" vertical="bottom"
        horizontal="end" slot="fixed">
        <ion-fab-button @click="choosePostType">
          <ion-icon :icon="pencil"></ion-icon>
        </ion-fab-button>
      </ion-fab>
      <ion-fab id="posting-button" v-if="isMyProfile && this.reporter == 1 && this.$store.state.helpers.postToggle == ''"
        vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button>
          <ion-icon :icon="pencil"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="start">
          <ion-fab-button color="primary" @click="openPostModal('post')">
            <ion-icon :icon="pencil"></ion-icon>
          </ion-fab-button>
          <ion-fab-button @click="openPostModal('ecb')">
            <img src="/assets/ecb_btn.png">
          </ion-fab-button>
        </ion-fab-list>
      </ion-fab>
      <ion-fab id="posting-button" v-if="isMyProfile && this.reporter != 1 && this.$store.state.helpers.postToggle == ''"
        vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button @click="openPostModal('post')">
          <ion-icon :icon="pencil"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, actionSheetController, IonCol, IonGrid, IonRow, IonButton, IonIcon, popoverController, IonSegment, IonSegmentButton, IonLabel, modalController, IonChip, isPlatform, getPlatforms, alertController, IonFab, IonFabButton, IonFabList, IonHeader, toastController, IonRefresher, IonRefresherContent } from '@ionic/vue';
import { pencil, search, cog, ellipsisHorizontal, link, personAdd, chatbubble, share, notifications, person, lockClosed, checkmark, arrowBack, chevronDownCircleOutline } from 'ionicons/icons';
import { defineAsyncComponent } from 'vue'
import { Share } from '@capacitor/share';
import { Browser } from '@capacitor/browser';

//import FeedContainer from '@/components/FeedContainer.vue';
const FeedContainer = defineAsyncComponent(() =>
  import('@/components/FeedContainer.vue'))

import Popover from '@/components/Popover.vue'
import ShareOtherModal from '@/components/ShareOtherModal.vue'
import BuyModal from '@/components/BuyModal.vue'
import ReportPostModal from '@/components/posts/ReportPost.vue'
import getEnv from '@/utils/env'
import PostModal from '@/components/posts/CreatePost.vue';
import SignupModal from '@/components/SignupModal.vue'
import PhotoView from '@/components/PhotoView.vue'
import HeaderContainer from '@/components/HeaderContainer.vue';
import UserBadges from '@/components/UserBadges.vue';

export default {
  name: 'ProfileView',
  components: { FeedContainer, IonContent, IonPage, IonCol, IonGrid, IonRow, IonButton, IonIcon, IonSegment, IonSegmentButton, IonChip, IonLabel, IonFab, IonFabButton, IonFabList, HeaderContainer, IonHeader, IonRefresher, IonRefresherContent, UserBadges },
  setup() {
    return {
      search,
      cog,
      ellipsisHorizontal,
      link,
      personAdd,
      chatbubble,
      share,
      notifications,
      person,
      lockClosed,
      getEnv,
      checkmark,
      arrowBack,
      isPlatform,
      getPlatforms,
      pencil,
      chevronDownCircleOutline
    }
  },
  data() {
    return {
      scrollElement: null,
      path: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET'),
      storepath: getEnv('AWS_URL') + getEnv('PREMIUM_BUCKET'),
      profilepath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/profile/',
      bannerpath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/banner/',
      filterType: null,
      profileType: '',
      profileSwitch: 'stories',
      keyIndex: 0,
      link_url: '',
      title: 'Profile',
      refreshFeed: false,
      notFound: false,
      report: false,
      timeout: false
    }
  },
  async ionViewDidEnter() {
    if (this.$route.name == "share") {
      if (this.$store.state.auth.token != '') {
        this.$router.replace({ name: 'profile', params: { id: this.$store.state.profile.id } });
      }
    }

    if (this.$route.params.id != null && this.$route.params.id == this.$store.state.profile.id) {
      this.profileType = "myprofile";
    }else{
      this.profileType = "profile";
    }
    this.getNewsfeed();
    
    this.$store.commit('profile/setPageRequest', []);
    if (this.$route.params.id != null && this.$route.params.id != 0 && this.$route.params.id != this.$store.state.profile.profilePageData.id) {
      let response = await this.$store.dispatch("profile/otherUserInfo", { userId: this.$route.params.id });
      if(response!=undefined){
        if (response.error != null || response.id == undefined) {
          this.$router.replace({ name: 'PageNotExist'});
        }
      }
    } else if (this.$route.params.username != null && this.$route.params.username != 0 && this.$route.params.username != this.$store.state.profile.profilePageData.user_name) {
      let response = await this.$store.dispatch("profile/otherUserInfo", { username: this.$route.params.username });
      if(response!=undefined){
        if (response.error == null && response.id != undefined) {
          //console.log('found it');
          this.$router.replace({ name: 'profile', params: { id: response.id } });
        } else {
          //console.log('go to 404');
          this.$router.replace({ name: 'PageNotExist'});
          //this.notFound = true;
        }
      }
    }

    if (this.$route.query.link != null) {
      this.link_url = this.$route.query.link + ' ';
      this.$route.query.link = '';
      await this.openPostModal('post');
    }else{
      this.link_url = '';
    }
    
    this.$store.dispatch("header/custom", {
      title: this.profile.user_name,
      description: this.profile.bio,
      url: 'https://' + getEnv('SHARE_HOSTNAME') + this.$route.fullPath,
      pik_name: this.profilepath + this.profile.profile_pic,
      width: '640',
      height: '640'
    });

    if (this.$store.state.helpers.autoFollow != '') {
      //console.log(this.$store.state.helpers.autoFollow, 'auto follow');
      var friendId = this.$store.state.helpers.autoFollow;
      let response = await this.$store.dispatch("profile/friend", {
        id: friendId
      });
      if (response['error'] != undefined) {
        this.$store.commit('helpers/setAutoFollow', '');
        console.log('Error: ' + response['error']);
      } else {
        //console.log(response);
        this.$store.commit('helpers/setAutoFollow', '');
      }
    }
  },
  async mounted() {
    this.scrollElement = await this.$refs.profileContent.$el.getScrollElement();
    //console.log(this.scrollElement, 'scroll element');
  },
  methods: {
    async getNewsfeed() {
      if (this.$route.params.id != null && this.$route.params.id == this.$store.state.profile.id) {
        console.log(this.profileType, 'type');
        if (this.$store.state.pikstream.myProfileResponseData == null) {
          let response = await this.$store.dispatch("pikstream/getStream", {
            streamName: this.profileType,
            filter: null,
            imageid: null,
            storyid: null,
            total_list: this.$store.state.pikstream.totalList.myprofile,
            last_id: this.$store.state.pikstream.lastId.myprofile,
            userid: null
          });
          if (response != undefined) {
            if (response.error != undefined) {
              console.log('there was an error1', response.error);
              this.timeout = true;
            }
          }
        }
      } else {
        if (this.$store.state.pikstream.profileResponseData[this.$route.params.id] == null) {
          let response = await this.$store.dispatch("pikstream/getStream", {
            streamName: this.profileType,
            filter: null,
            imageid: null,
            storyid: null,
            total_list: 7,
            last_id: 0,
            userid: this.$route.params.id
          });

          if (response != undefined) {
            if (response.error != undefined) {
              console.log('there was an error2', response.error);
              this.timeout = true;
            }
          }
        }
      }
    },
    async openPopover(ev, profile) {
      var type = 'profile-websites';
      if (profile.allwebsites.length > 0) {

        const popover = await popoverController
          .create({
            component: Popover,
            cssClass: 'my-custom-class',
            event: ev,
            translucent: true,
            componentProps: {
              name: this.$t('buttons.websites'),
              type: type,
              data: profile.allwebsites
            }
          })
        await popover.present();

        const { role } = await popover.onDidDismiss();
        console.log('onDidDismiss resolved with role', role);
      }
    },
    async choosePostType() {
      if (this.reporter == 1) {
        const actionSheet = await actionSheetController.create({
          header: this.$t('modalhead.createpost'),
          buttons: [
            {
              text: this.$t('buttons.reportPost'),
              data: {
                action: 'post',
              },
            },
            {
              text: this.$t('buttons.reportElection'),
              data: {
                action: 'report',
              },
            },
            {
              text: this.$t('buttons.cancel'),
              role: 'cancel',
              data: {
                action: 'cancel',
              },
            },
          ],
        });

        await actionSheet.present();
        let dismissed = await actionSheet.onDidDismiss();
        if (dismissed != undefined) {
          if (dismissed.data.action != 'cancel') {
            if (dismissed.data.action == 'report') {
              await this.openPostModal('ecb');
            }
          }
          //console.log(dismissed.data, 'data');
        }
      } else {
        this.openPostModal('post');
      }

    },
    async openPostModal(type) {
      if (this.$store.state.auth.token != '') {
        let title = this.$t('modaltitle.createpost');
        this.report = false;
              
        if (type == 'ecb') {
          this.report = true;
          title = this.$t('buttons.reportElection');
        }
        const modal = await modalController
          .create({
            component: PostModal,
            cssClass: 'modal-custom-class',
            backdropDismiss: false, // Prevent dismissal by clicking outside
            componentProps: {
              title: title,
              share_link: this.link_url,
              report: this.report
            }
          })
        this.refreshFeed = false;
        await modal.present();

        const dismissed = await modal.onDidDismiss();
        if (dismissed.role != 'canceled') {
          if(dismissed.role=='goLive'){
            console.log('go live');
            this.$router.push({ name: 'livebroadcast' });
          }else{
            this.presentToast('top', 'Your post was sent!', dismissed.data.id);
          }
          this.report = false;
          if(dismissed.role!='groups' && dismissed.role!='elections'){
            this.refreshFeed = true;
          }
        }
      }
    },
    async presentToast(position, message, image_id) {
      const toastButtons = [
        {
          text: 'View Post',
          role: 'info',
          handler: () => {
            console.log('More Info clicked');
            this.$router.push({ name: 'story', params: { imageid: image_id } });
          },
        },
        {
          text: 'Dismiss',
          role: 'cancel',
          handler: () => {
            console.log('Dismiss clicked');
          },
        },
      ];
      const toast = await toastController.create({
        message: message,
        duration: 7000,
        position: position,
        buttons: toastButtons,
        color: 'primary'
      });

      await toast.present();
    },
    async openShareOtherModal() {
      //const sliderImage = await this.getImageData(index);
      let canShare = await Share.canShare();
      if (canShare.value) {
        await this.nativeShare();
      } else {
        const modal = await modalController
          .create({
            component: ShareOtherModal,
            cssClass: 'shareother-custom-class',
            componentProps: {
              title: this.$t('modalhead.shareprofile'),
              username: this.profile.user_name
            }
          })
        return await modal.present();
      }
    },
    async nativeShare() {
      let postLink = "";
      if (isPlatform('hybrid') || isPlatform('electron')) {
        postLink = 'https://' + getEnv('SHARE_HOSTNAME') + '/u/' + this.profile.user_name;
      } else {
        postLink = 'https://' + window.location.hostname + '/u/' + this.profile.user_name;
      }

      await Share.share({
        title: this.$t('modalhead.shareprofile'),
        text: '',
        url: postLink,
        dialogTitle: this.$t('modalhead.shareprofile'),
      });

    },
    async openBlockModal() {
      const modal = await modalController
        .create({
          component: ReportPostModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: this.$t('modalhead.blockuser'),
            user: this.profile,
            type: 1
          }
        })
      return await modal.present();
    },
    async openBuyModal() {
      if (this.$store.state.auth.token != '') {
        /* var visibleStores = this.profile.visible_stores;
        var selectedStore = {};
        for(var i=0; i<visibleStores.length; i++){
          if(visibleStores[i]['id'] == this.profile.total_access_on_profile){
            selectedStore = visibleStores[i];
          }
        } */
        let title = this.$t('buttons.premiumcontent');
        if (this.profile.premium_content != 1) {
          title = 'Sponsor';
        }
        const modal = await modalController
          .create({
            component: BuyModal,
            cssClass: 'modal-custom-class',
            componentProps: {
              title: title,
              //user_id: this.profile.id,
              profile: this.profile,
              isMyProfile: this.isMyProfile
            }
          })
        await modal.present();

        const { role } = await modal.onDidDismiss();
        if (role == "subscribed") {
          this.profile.is_subscribed = true;
        }
      } else {
        this.presentLoginAlertConfirm('buy');
      }
    },
    checkIosApp() {
      let iosCheck = false;
      if (isPlatform('hybrid') && isPlatform('ios')) {
        iosCheck = true;
      }
      return iosCheck;
    },
    async viewFriends(friendType) {
      /* this.$store.state.profile.profilePageData = null;
      this.$store.state.profile.profileData = null;
      this.$store.state.profile.profilePageStats = null; */
      if (this.$store.state.auth.token != '') {
        var type = 0;
        if (friendType == "followme") {
          type = 1;
        } else if (friendType == "myfollows") {
          type = 2;
        }

        if (this.$route.params.id != undefined || this.$route.params.username != undefined) {
          this.$router.push({ name: 'friends', params: { id: this.profile.id, type: type } })
        } else {
          this.$router.push({ name: 'friends', params: { id: 0, type: type } })
        }
      } else {
        this.presentLoginAlertConfirm('viewfriends');
      }
    },
    async presentLoginAlertConfirm(type) {
      var title = this.$t('alerthead.login');
      var message = this.$t('alertmessage.login', { app: getEnv('APP_NAME') });
      if (type == "friend") {
        title = this.$t('alerthead.loginfriend', { app: getEnv('APP_NAME') });
        message = this.$t('alertmessage.loginfriend');
        this.$store.commit('helpers/setAutoFollow', this.profile.id);
      } else if (type == "viewfriends") {
        title = this.$t('alerthead.loginview');
        message = this.$t('alertmessage.loginview');
      } else if (type == "buy") {
        title = this.$t('alerthead.loginbuy');
        message = this.$t('alertmessage.loginbuy', { user: this.profile.first_name });
      }

      this.$store.commit('helpers/setRedirectLogin', this.$route.path);

      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: title,
          message: message,
          buttons: [
            {
              text: this.$t('buttons.signup'),
              handler: () => {
                this.signup();
              },
            },
            {
              text: this.$t('buttons.login'),
              handler: () => {
                this.login();
              },
            },
            {
              text: this.$t('buttons.cancel'),
              role: 'cancel',
              cssClass: 'secondary',
            },
          ],
        });
      return alert.present();
    },
    signup() {
      if(getEnv('APP_NAME') == 'VoclNEW'){
        this.fsbnConnect('signup');
      }else{
        this.presentSignup('signup');
      }
    },
    login() {
      if(getEnv('APP_NAME') == 'VoclNEW'){
        this.fsbnConnect('login');
      }else{
        this.presentSignup('login');
      }
      
    },
    async openLink(link_url) {
      if (link_url != '') {
        if (isPlatform('hybrid') || isPlatform('electron')) {
          await Browser.open({ url: link_url, presentationStyle: 'popover' });
        }else{
          window.open(link_url, '_blank');
        }
      }
    },
    async fsbnConnect(type) {
      let redirect = 'https://' + window.location.hostname + '/idauth';
      if (isPlatform('hybrid') || isPlatform('electron')) {
        redirect = 'https://' + getEnv('SHARE_HOSTNAME') + '/idauth';
      }
      const client_id = 'ceb0f61a-976b-4b29-a59f-55ec3f600d6f';
      let url_add = '';
      if(type=="signup") url_add = '&goto=signup';
      if(getEnv('REQUEST_URL')=='https://api.vocl.com/'){
        this.openLink('https://signin.frankspeech.com/OAuth/Start?redirect_uri='+redirect+'&client_id='+client_id+'&response_type=code&state='+type+url_add);
      }else{
        this.openLink('https://test-signin.frankspeech.com/OAuth/Start?redirect_uri='+redirect+'&client_id='+client_id+'&response_type=code&state='+type+url_add);
      }
    },
    async presentSignup(type, button) {
      let title = this.$t('buttons.login');
      if (type == "signup") {
        title = this.$t('buttons.signup');
      }
      const modal = await modalController
        .create({
          component: SignupModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: title,
            loginType: type,
            source: 'link'
          }
        })
      await modal.present();

      const { role } = await modal.onDidDismiss();
      if (role == 'loggedin') {
        if (button == 'buy') {
          this.openBuyModal();
        }
      }
    },
    showIcon() {
      return personAdd;
    },
    async toggleFriend(friend) {
      if (this.$store.state.auth.token != '') {
        if (this.profile.status.id == 0) {
          if (this.profile.status.private == 1) {
            let response = await this.$store.dispatch("profile/friendRequest", {
              id: friend.id
            });
            if (response['error'] != undefined) {
              console.log('Error: ' + response['error']);
            } else {
              this.profile.status.requested = 'yes';
            }
          } else {
            let response = await this.$store.dispatch("profile/friend", {
              id: friend.id
            });
            if (response['error'] != undefined) {
              console.log('Error: ' + response['error']);
            } else {
              this.profile.status.id = friend.id;
            }
          }

        } else {
          if (this.profile.status.private != 1 || (this.profile.status.private == 1 && this.profile.status.requested == 'no')) { //
            let response = await this.$store.dispatch("profile/unfriend", {
              id: friend.id
            });
            if (response['error'] != undefined) {
              console.log('Error: ' + response['error']);
            } else {
              this.profile.status.id = 0;
            }
          }
        }
      } else {
        this.presentLoginAlertConfirm('friend');
      }
    },
    async profileTypeChanged(ev) {
      let segmentValue = ev.target.value;
      this.profileSwitch = segmentValue;
      if (!this.isMyProfile) {
        if (segmentValue == "subscriptions") {
          this.profileType = "ownerpreviewpremium";
        } else if (segmentValue == "stories") {
          this.profileType = "profile";
        }
        this.$store.commit('pikstream/setProfileRequestNull', this.profile.id);
      } else {
        if (segmentValue == "subscriptions") {
          this.profileType = "premium";
        } else if (segmentValue == "stories") {
          this.profileType = "myprofile";
        } else if (segmentValue == "forsale") {
          this.profileType = "ownerpremium";
        }

        this.$store.commit('pikstream/setMyProfileRequest', null);
        this.$store.commit('pikstream/setProfileRequestNull', this.profile.id);
      }
      this.getNewsfeed();
    },
    async openFullScreen(image, width, height) {
      const modal = await modalController
        .create({
          component: PhotoView,
          cssClass: 'fullscreen',
          componentProps: {
            image: image,
            width: width,
            height: height
          }
        })
      await modal.present();

      const { role } = await modal.onDidDismiss();
      console.log(role);
    },
    displaySubscribeButton() {
      let buttonLabel = '';
      if (this.profile.premium_content == 1) {
        buttonLabel = this.$t('buttons.subscribe');
      } else {
        buttonLabel = this.$t('buttons.sponsor');
      }
      return buttonLabel;
    },
    imgUrlAlt(event) {
      event.target.src = "/assets/spyguy.png";
    },
    dashMarginOverride() {
      let margin = '';
      if (this.$store.state.auth.token == '') {
        margin = 'margin-right:auto; margin-left:auto;';
      }
      return margin;
    },
    async doRefresh(event) {
      //console.log('do refresh', this.feedSwitch);
      this.refreshFeed = true;
      setTimeout(() => {
          event.target.complete();
        }, 500); 
    },
  },
  computed: {
    profileStories() {
      if (this.$route.params.id != undefined) {
        if (this.$store.state.pikstream.profileResponseData[this.$route.params.id] != null) {
          return this.$store.state.pikstream.profileResponseData[this.$route.params.id];
        }
      }
      return null;
    },
    myProfileStories() {
      if (this.$store.state.pikstream.myProfileResponseData != null) {
        return this.$store.state.pikstream.myProfileResponseData;
      }
      return null;
    },
    profileid() {
      if (this.$route.params.id != undefined) {
        return parseInt(this.$route.params.id);
      } else {
        return 0
      }
    },
    profile() {
      if (this.$route.params.id != undefined && this.$store.state.profile.profilePageData[this.$route.params.id] != undefined) {
        //console.log(this.$store.state.profile.profilePageData[this.$route.params.id], 'profile');
        return this.$store.state.profile.profilePageData[this.$route.params.id];
      } else {
        return {};
      }
    },
    isMyProfile() {
      if (this.profile.id != null && this.profile.id == this.$store.state.profile.id) {
        return true;
      } else {
        return false;
      }
    },
    isBlocked() {
      return this.$store.state.profile.isBlocked;
    },
    reporter() {
      return this.$store.state.profile.reporter;
    },
    userStats() {
      if (this.$route.params.id != null) {
        if (this.$store.state.profile.profilePageStats == undefined || this.$store.state.profile.profilePageStats.user_id != this.$route.params.id) {
          //console.log('no data');
          this.$store.dispatch("profile/stats", { userId: this.$route.params.id });
          return [];
        } else {
          return this.$store.state.profile.profilePageStats;
        }
      } else if (this.$route.params.username != null) {
        if (this.$store.state.profile.profilePageStats == undefined || this.$store.state.profile.profilePageStats.user_id != this.profile.id) {
          if (this.profile.id != undefined) {
            this.$store.dispatch("profile/stats", { userId: this.profile.id });
          }
          return [];
        } else {
          return this.$store.state.profile.profilePageStats;
        }
      } else {
        if (this.$store.state.profile.profilePageStats == undefined || this.$store.state.profile.profilePageStats.user_id != null) {
          //console.log('my profile no data');
          //console.log('get stats again');
          this.$store.dispatch("profile/stats", { userId: null });
          return [];
        } else {
          //console.log('stats available');
          //console.log(this.$store.state.profile.profilePageStats);
          return this.$store.state.profile.profilePageStats;
        }
      }
    }
  }
}
</script>
